import type { Router } from 'vue-router'
import { useUserStore } from '@/store'
import { WhiteRoutes } from '@/router'
import { PAGE_NAME, AUTHORITY } from '@/enums'
import { IS, getEntries } from '@da-vinci/utils'

const whiteNameList = WhiteRoutes.map((o) => o.name)

export function createPermissionGuard(router: Router) {
  router.beforeEach(async (to, from, next) => {
    if (to.hash) {
      const fullPath = to.hash.split('#')?.[1] || ''
      const query = getEntries(to.query).reduce((acc, [key, val]) => {
        if (IS.isArray(val)) {
          acc.push(...val.map((v) => ({ key, val: v })))
        } else {
          acc.push({ key, val })
        }
        return acc
      }, [] as { key: string; val: any }[])
      const queryStr = query.length ? '?' + query.map(({ key, val }) => `${key}=${val}`).join('&') : ''
      return next(fullPath + queryStr)
    }

    const authority = to.meta.authority as AUTHORITY | undefined
    const store = useStore()
    const token = store.user.token
    const goLogin = () => {
      const params = {
        name: PAGE_NAME.LOGIN,
        replace: true,
        query: { redirect: to.fullPath },
      }
      if (!to.path) {
        // @ts-ignore
        delete params.query
      }
      next(params)
    }

    // 初始化用户信息
    if (token && store.user.noneInit) {
      store.initIng = true
      try {
        await store.user.initUser()
      } finally {
        store.initIng = false
      }
    }

    // 白名单
    if (whiteNameList.includes(to.name || undefined)) {
      if (to.name === PAGE_NAME.LOGIN && token) {
        // 登录状态下进入 login
        return next((to.query?.redirect as string) || { name: PAGE_NAME.ROOT })
      }
      return next()
    }

    // 未登录
    if (!token) {
      return goLogin()
    }
    if (token && !store.user.userInfo) {
      return goLogin()
    }

    if (typeof authority !== 'undefined') {
      const callback = typeof authority === 'function' ? authority : (e: any) => authority === e
      if (!callback(store.user.authority)) {
        switch (store.user.authority) {
          case AUTHORITY.ok:
            return next({ name: PAGE_NAME.INSIGHT_LIST })
          case AUTHORITY.needChooseTenant:
            return next({ name: PAGE_NAME.Tenant })
          case AUTHORITY.needFirstSet:
            return next({ name: PAGE_NAME.NOT_SET })
          case AUTHORITY.needLogin:
            return next({ name: PAGE_NAME.LOGIN, query: { redirect: to.fullPath } })
        }
      }
    }

    if (to.name === PAGE_NAME.PAGE_NOT_FOUND) {
      return next({ path: to.fullPath, replace: true, query: to.query })
    } else {
      return next()
    }
  })
}
